;(function($, undefined){
    "use strict";

    var rnn = window.rnn,
        cachedMenu,
        cachedDayLabels,
        cachedWeek,
        cachedDay,
        dayLabels = [
            "sunday",
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday"
        ],
        monthLabels = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        defaultSettings = {
            date: new Date(),
            selectedDate: new Date()
        };

    /////////////////////
    // Create Calendar Menu
    /////////////////////
    function createCalendarMenu(){

        //Cache the result so its faster next time

        var $newMenu = $((cachedMenu = cachedMenu || (function(){
            var $calendarMenu = $(document.createElement("div")).addClass("calendarMenu"),
                $calendarLabel = $(document.createElement("div")).addClass("calendarLabel"),
                $prevMonth = $(document.createElement("button")).attr("type","button").addClass("calendarControls prev"),
                $nextMonth = $(document.createElement("button")).attr("type","button").addClass("calendarControls next");

            $calendarMenu.append($prevMonth, $calendarLabel, $nextMonth);

            return $calendarMenu[0];

        }())).cloneNode(true));

        return $newMenu;
    }

    /////////////////////
    // Update Calendar Menu
    /////////////////////
    function updateCalendarMenu($calendar, date){
        $calendar.find('.calendarLabel').text(monthLabels[date.getMonth()] + ' ' + date.getFullYear());
    }

    /////////////////////
    // Create New Day
    /////////////////////
    function createDay(date, settings, isSelectedDay, isDayInMonth){

        //Cache the result so its faster next time

        var $newDay = $((cachedDay = cachedDay || (function(){
                var $dayContainer = $(document.createElement("td")).addClass("dayContainer"),
                    $day = $(document.createElement("a")).addClass("day"),
                    $dayNumber = $(document.createElement("span")).addClass("dayNumber");

                $dayContainer.append($day.append($dayNumber));

                return $dayContainer[0];

            }())).cloneNode(true)),
            now = new Date();

        $newDay.data("date", date).find('.dayNumber').text(date.getDate());

        if(isDayInMonth === false){
            $newDay.addClass('outsideMonth');
        }

        if(isSelectedDay){
            $newDay.addClass('selected');
        }

        if(settings.requestUrl && now > date && now < new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)){
            $newDay.addClass('today');
        }

        return $newDay;
    }

    /////////////////////
    // Create New Week
    /////////////////////
    function createWeek(){

        //Cache the result so its faster next time

        return $((cachedWeek = cachedWeek || (function(){
            return $(document.createElement("tr")).addClass("week")[0];
        }())).cloneNode(true));
    }

    /////////////////////
    // Create Day Labels
    /////////////////////
    function createDayLabels(){

        //Cache the result so its faster next time

        return $((cachedDayLabels = cachedDayLabels || (function(){
            var $dayLabels = $(document.createElement("tr"));

            for(var dayNumber = 0; dayNumber < 7; dayNumber++){ // 6 weeks, 7 days. Show 6 weeks at a time
            var $dayLabel = $(document.createElement("th")).addClass("dayLabel");

            $dayLabel.text(dayLabels[dayNumber].slice(0,3));

            $dayLabels.append($dayLabel);
        }

        return $dayLabels[0];

        }())).cloneNode(true));
    }

    /////////////////////
    // Retrieve calendar search results from the server.
    /////////////////////
    function retrieveSearchResults(settings, date, callback){
        // Add a blank month
        var year = date.getFullYear(),
            month = date.getMonth();

        settings.searchResults[year] = settings.searchResults[year] || {};
        settings.searchResults[year][month + 1] = {};

        $.ajax({
            url:settings.requestUrl + (settings.requestUrl.indexOf("?") < 0 ? "?" : "&") + "year=" + year + "&month=" + (month + 1),
            dataType:"json",
            contentType:"aplication/json",
            success: function(data){
                if(data.searchResults){
                    $.extend(true, settings, data);
                    callback(settings);
                }
            },
            error: function(){
                // error
            }
        });
    }

    /////////////////////
    // Set search results on the days in a month, if any exist
    /////////////////////
    function setHasSearchResults(setHasSearchResultsList, settings){
        setHasSearchResultsList.fastEach(function($day){
            var date = $day.data("date"),
                year,
                month,
                monthSearchResults;

            year = date.getFullYear();
            month = date.getMonth();
            monthSearchResults = settings.searchResults[year] && settings.searchResults[year][month + 1];

            // If there's no requestUrl on the settings object, assume every day has search results.
            // Otherwise, check either the local settings or fetch them from the server
            if(!settings.requestUrl || monthSearchResults){
                if(!settings.requestUrl || monthSearchResults[date.getDate()]){
                    if(!settings.disableCaret){
                        $day.addClass("hasSearchResults");
                    }
                    $day.find(".day").attr("href", settings.searchUrl + (settings.searchUrl.indexOf("?") < 0 ? "?" : "&") + "date=" + year + "-" + (month + 1)+ "-" + date.getDate());
                }
            }else{
                retrieveSearchResults(settings, date, function(settings){
                    setHasSearchResults(setHasSearchResultsList, settings);
                });
            }
        });
    }

    /////////////////////
    // Create and Show Calendar Page
    /////////////////////
    function showMonth($calendar, date){
        var newDays = [],
            year = date.getFullYear(),
            month = date.getMonth(),
            isSearchResultsCalendar = $calendar.hasClass('search-results-calendar'),
            settings = isSearchResultsCalendar ? $calendar.data("searchResultsCalendar") : $calendar.data("datePickerCalendar"),
            $month = $calendar.find(".month"),
            firstDay = new Date(year, month, 1),
            dayOfWeekOffset = firstDay.getDay(),
            daysInMonth = new Date(year, month + 1, 0).getDate(); // +1 to month to get next month, then day 0 gets last day of prev month.

        //clear calendar
        $month.children().detach();

        if(isSearchResultsCalendar && settings.searchResults[year] && settings.searchResults[year][month + 1] && settings.searchResults[year][month + 1].renderedMonth){
            $month.append(settings.searchResults[year][month + 1].renderedMonth);
        }else{
            var $renderedMonth = $().add(createDayLabels());

            //Check

            // Weeks
            for(var week = 0; week < 6; week++){ // 6 weeks

                var $weekContainer = createWeek();

                // Days
                for(var i = 0; i < 7; i++){ // 7 days.

                    var day = new Date(year, month, 1 - dayOfWeekOffset + i + (week * 7)),
                        isDayInMonth = day >= firstDay && day <= new Date(firstDay.getFullYear(), firstDay.getMonth(), daysInMonth),
                        isSelectedDay = day >= settings.selectedDate && day < new Date(settings.selectedDate.getFullYear(), settings.selectedDate.getMonth(), settings.selectedDate.getDate() + 1),
                        $day;

                    if (!isSearchResultsCalendar) {
                        isSelectedDay = !!settings.selectedDates[day.toString()];
                    }

                    $day = createDay(day, settings, isSelectedDay, isDayInMonth);

                    $weekContainer.append($day);
                    newDays.push($day);
                }

                $renderedMonth = $renderedMonth.add($weekContainer);
            }

            $month.append($renderedMonth);

            // Check if there are search results this month.
            // If the month object does not exist, request data from the server.
            if(window.location.pathname.indexOf('/search/') === -1){ // not ideal. remove once BE fix is in
                if (isSearchResultsCalendar) {
                    setHasSearchResults(newDays, settings);
                    // If there's no requestUrl on the settings object, assume every day has search results,
                    // and create the required data structure to hold the rendered month
                    if (!settings.requestUrl) {
                        settings.searchResults[year] || (settings.searchResults[year] = []);
                        settings.searchResults[year][month + 1] || (settings.searchResults[year][month + 1] = {});
                    }
                    settings.searchResults[year][month + 1].renderedMonth = $renderedMonth;
                }
            }
        }
    }

    /////////////////////
    // Init Calendars
    /////////////////////
    function initSearchResultsCalendars() {
        rnn.modules.user.get(function (user) {

            //Initialise All Search Results Calendars
            $(".search-results-calendar").each(function(){
                var $this = $(this),
                    settings = $.extend(true, {}, defaultSettings, $this.data("searchResultsCalendar")),
                    $calendarMenu = createCalendarMenu();

                settings.user = user;

                //update the calendars settings object
                $this.data("searchResultsCalendar", settings);

                $this.append($calendarMenu);

                updateCalendarMenu($this, settings.date);

                $this.append($(document.createElement("table")).attr("cellpadding", 0).addClass("month"));

                showMonth($this, settings.date);
            });

            //Initialised Calendar controls
            $(document).delegate(".search-results-calendar .calendarControls", "click", function(){
                var $this = $(this),
                    $calendar = $this.closest(".search-results-calendar"),
                    settings = $calendar.data("searchResultsCalendar");

                settings.selectedDate = settings.selectedDate || settings.date;

                if($this.is(".prev")){
                    settings.selectedDate = new Date(settings.selectedDate.getFullYear(), settings.selectedDate.getMonth() - 1, settings.selectedDate.getDate());
                }else{
                    settings.selectedDate = new Date(settings.selectedDate.getFullYear(), settings.selectedDate.getMonth() + 1, settings.selectedDate.getDate());
                }

                updateCalendarMenu($calendar, settings.selectedDate);

                showMonth($calendar, settings.selectedDate);
            });

            //Initialise Day Events.
            $(document).delegate(".search-results-calendar .dayContainer", "click", function(){
                var $this = $(this),
                    $calendar = $this.closest(".search-results-calendar"),
                    settings = $calendar.data("searchResultsCalendar"),
                    date = $this.data("date");

                settings.selectedDate = date;

                if($this.is(".outsideMonth")){
                    updateCalendarMenu($calendar, settings.selectedDate);

                    showMonth($calendar, settings.selectedDate);
                }else{
                    $calendar.find(".selected").removeClass("selected");
                    $this.addClass("selected");
                }
            });

        });

    }

    function initDatePickerCalendars() {
        $(".date-picker-calendar").each(function(){
            var $this = $(this),
                settings = $.extend(true, {}, defaultSettings, $this.data("datePickerCalendar")),
                $calendarMenu = createCalendarMenu(),
                $hiddenField = $("#" + settings.hiddenFieldID);

            //update the calendars settings object
            $this.data("datePickerCalendar", settings);

            $hiddenField.val() && $.each($hiddenField.val().split(","), function (index, value) {
                var dateComponents = value.split("/");
                var date = new Date(dateComponents[2], dateComponents[0] - 1, dateComponents[1]);
                settings.selectedDates[date.toString()] = date;
            });

            $this.closest("form").one("submit", function () {
                var $form = $(this);
                var validDates = [];
                $.each(settings.selectedDates, function (key, value) {
                    if (value.getFullYear) {
                        validDates.push(value);
                    }
                });
                var hiddenFieldUpdatedVal = $.map(validDates, function (value) {
                    return [value.getMonth() + 1, value.getDate(), value.getFullYear()].join("/");
                }).join(",");
                $("#" + settings.hiddenFieldID).val(hiddenFieldUpdatedVal);
                $form.submit();
                return false;
            });

            $this.append($calendarMenu);

            updateCalendarMenu($this, settings.date);

            $this.append($(document.createElement("table")).attr("cellpadding", 0).addClass("month"));

            showMonth($this, settings.date);
        });

        //Initialised Calendar controls
        $(document).delegate(".date-picker-calendar .calendarControls", "click", function(){
            var $this = $(this),
                $calendar = $this.closest(".date-picker-calendar"),
                settings = $calendar.data("datePickerCalendar");

            settings.selectedDate = settings.selectedDate || settings.date;

            if($this.is(".prev")){
                settings.selectedDate = new Date(settings.selectedDate.getFullYear(), settings.selectedDate.getMonth() - 1, settings.selectedDate.getDate());
            }else{
                settings.selectedDate = new Date(settings.selectedDate.getFullYear(), settings.selectedDate.getMonth() + 1, settings.selectedDate.getDate());
            }

            updateCalendarMenu($calendar, settings.selectedDate);

            showMonth($calendar, settings.selectedDate);
        });

        //Initialise Day Events.
        $(document).delegate(".date-picker-calendar .dayContainer", "click", function(){
            var $this = $(this),
                $calendar = $this.closest(".date-picker-calendar"),
                settings = $calendar.data("datePickerCalendar"),
                date = $this.data("date"),
                today = new Date();

            if (date) {
                settings.selectedDate = date;

                if($this.is(".outsideMonth")){
                    updateCalendarMenu($calendar, settings.selectedDate);

                    showMonth($calendar, settings.selectedDate);
                }else{
                    if (date < today && date.getDate() < today.getDate()) {
                        alert("You cannot select a date in the past.");
                    } else {
                        if ($this.hasClass("selected")) {
                            delete settings.selectedDates[date.toString()];
                            $this.removeClass("selected");
                        } else {
                            settings.selectedDates[date.toString()] = date;
                            $this.addClass("selected");
                        }
                    }
                }
            }
        });
    }

    function initCalendars(){
        initSearchResultsCalendars();
        initDatePickerCalendars();
    }

    rnn.modules.register("calendar", {
        init: initCalendars
    });

})(jQuery);
